import { checkLobAddress } from './checkLobAddress';
import { getPlaceTypesByGeocode } from './getPlaceTypesByGeocode';

export const addressService = {
  checkLobAddress,
  getPlaceTypesByGeocode,
};
